import { Timestamp } from 'firebase/firestore';

/**
 * 操作種別
 */
export enum ResultHistoryActionType {
  UNKNOWN = 0, // action_type 欠損レコード用フォールバック（集計対象外）
  CREATE = 1, // 作成
  EDIT = 2, // 編集
  STATUS_CHANGE = 3, // ステータス変更
  DELETE = 4, // 削除
}

/**
 * 履歴レコード型
 */
export interface ResultHistory {
  history_id: string;
  action_type: ResultHistoryActionType;
  changed_fields?: Record<string, unknown>;
  previous_values?: Record<string, unknown>;
  user_id: string;
  user_name: string;
  created_at: Timestamp;
}

/**
 * 履歴作成リクエスト型
 */
export interface CreateResultHistoryRequest {
  result_id: string;
  action_type: ResultHistoryActionType;
  changed_fields?: Record<string, unknown>;
  previous_values?: Record<string, unknown>;
  user_id: string;
  user_name: string;
}
